// extracted by mini-css-extract-plugin
export var avatar = "_ok-3";
export var avatarContainer = "_ok-2";
export var avatarSpacer = "_ok-5";
export var avatarSpacerContainer = "_ok-4";
export var avatarStackContainer = "_ok-1";
export var bubble = "_ok-0";
export var remainderBubble = "_ok-6";